// helpers/demoMode.js
import config from "../config.json";
import { useUser } from "../pages/login/UserContextPersistent";

export const getIsDemo = () => {
  try {
    // Check if isDemo exists in localStorage
    const storedIsDemo = localStorage.getItem("isDemo") || "false";
    if (storedIsDemo !== null) {
      // Return the boolean value from localStorage
      return storedIsDemo === "true";
    }

    // Fallback to config value if not found in localStorage
    return config.isDemo;
  } catch (error) {
    console.error("Error reading isDemo from localStorage:", error);
    return config.isDemo; // Fallback to config on error
  }
};

export const useIsDemo = () => {
  const { isDemo } = useUser();
  return isDemo;
};

export const setIsDemo = () => {
  try {
    localStorage.setItem("isDemo", true);
    return true;
  } catch (error) {
    console.error("Error saving isDemo to localStorage:", error);
    return false;
  }
};

export const getSettingInfo = () => {
  try {
    const storedData = localStorage.getItem("setting_vehicle");
    return storedData ? JSON.parse(storedData) : null;
  } catch (error) {
    console.error("Error saving isDemo to localStorage:", error);
    return false;
  }
};

export const saveNextStopToStorage = (nextStop) => {
  if (nextStop) {
    localStorage.setItem("nextStopDetails", JSON.stringify(nextStop));
  }
};

export const getNextStopFromStorage = () => {
  const storedData = localStorage.getItem("nextStopDetails");
  return storedData ? JSON.parse(storedData) : null;
};
